export const TRANSLATIONS_EN = {
    accueil: "Accueil",
};